import store from '@/store';
import { AjaxDataProvider } from '@fps/vue-toolkit/dist/services/http/ajax-data-provider';
import { dataGet } from '@fps/vue-toolkit/dist/util';
// import router from '@/router';

export default {
  canActivate() {
    const dataPromiseArray = [];

    if (!dataGet('state.temp.categories', store)) {
      const initialCategory = {
        name: '',
        key: null,
        subcategories: []
      }
      store.commit('SET_TEMP', {
        key: 'categories',
        value: { list: Array(9).fill(initialCategory) }
      });
      new AjaxDataProvider('categories', {
        // Bring ad counters
        attribute_types: true,
        activeAds_count: true,
        'subcategories:attribute_types': true,
        'subcategories:activeAds_count': true,
      }).load();
    }

    return Promise.all(dataPromiseArray);
  },
};



// WEBPACK FOOTER //
// ./src/guards/app-data.js